
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import { z } from "zod";
import VueRouter, { Route } from "vue-router";
const phoneSchema = z
  .string()
  .nonempty({ message: "電話號碼為必填" })
  .refine(
    (val) => {
      if (val === "") {
        return true;
      }
      return (
        /^09\d{8}$/.test(val) || // 手機
        /^(0[2-8]\d{0,2})-?\d{5,8}$/.test(val) // 市話（排除 09 開頭）
      );
    },
    {
      message: "電話號碼格式不正確",
    }
  );

const formSchema = z.object({
  name: z.string().min(1, "姓名為必填"),
  email: z.email("Email 格式不正確"),
  phone: phoneSchema,
  text: z.string().min(1, "問題描述為必填"),
});

@Component
export default class HomeView extends Vue {
  public $route!: Route;
  public $router!: VueRouter;
  name = "";
  email = "";
  phone = "";
  text = "";
  gender = "";
  file: File | null = null;
  file2: File | null = null;
  file3: File | null = null;

  errors: Record<string, string> = {};
  private validateForm() {
    this.errors = {};
    const formDataObj = {
      name: this.name,
      email: this.email,
      phone: this.phone,
      text: this.text,
    };
    const result = formSchema.safeParse(formDataObj);

    if (!result.success) {
      for (const err of result.error.issues) {
        const key = String(err.path[0]);
        if (key) this.errors[key] = err.message;
      }
    }

    return result.success;
  }
  private buildFormData(): FormData {
    const formData = new FormData();
    type FieldKey = "name" | "gender" | "email" | "phone" | "text";
    const fields: FieldKey[] = ["name", "gender", "email", "phone", "text"];
    for (const key of fields) {
      formData.append(key, this[key]);
    }

    const files = [this.file, this.file2, this.file3].filter(Boolean);
    for (const file of files) {
      if (file) {
        formData.append("file", file, file.name);
      }
    }

    return formData;
  }
  async submit() {
    // 取得 URL query 參數
    const APPID = this.$route.query.a || "";
    const ONEID: any = this.$route.query.o;
    const SERVICE: any = this.$route.query.s;
    console.log("APPID=", APPID);
    console.log("ONEID=", ONEID);
    console.log("SERVICE=", SERVICE);

    const apiHost =
      window.location.hostname === "csip-contact.openhub.com.tw"
        ? "https://csip-app-api.openhub.com.tw"
        : "https://csip-app-api-dev.devsdc.com";
    console.log("apiHost", apiHost);
    // 根據是否有 SERVICE 參數決定 API URL
    const url = SERVICE
      ? `${apiHost}/contactus/v1/custom_service?a=${APPID}&o=${ONEID}&s=${SERVICE}`
      : `${apiHost}/contactus/v1/custom_service?a=${APPID}&o=${ONEID}`;

    try {
      // 驗證表單
      if (!this.validateForm()) return;

      // 組出 FormData
      const formData = this.buildFormData();

      // 發送 POST
      await axios.post(url, formData); // 移除錯誤的 Content-Type
      // 成功導向
      await this.$router.push("/about");
    } catch (e: any) {
      console.error(e);
    }
  }
}
